<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="AgendamentosDesativadosForm"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <label for="unidade">Unidade <sup>(1)</sup></label>
              <select
                id="unidade"
                v-model="filtro.unidade"
                data-test-id="select-unidade"
                name="unidade"
                class="form-control"
                @input="v$.filtro.unidade.$touch()"
              >
                <option disabled value="">Selecione</option>
                <option
                  v-for="unidade in unidades"
                  :key="unidade._id"
                  :value="unidade.nome"
                  >{{ unidade.nome }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div
              :class="{ 'has-error': v$.filtro.dataInicio.$error }"
              class="form-group"
            >
              <label for="dataInicio">Data Início <sup>(1)</sup></label>
              <div class="input-group">
                <input
                  id="dataInicio"
                  v-model="filtro.dataInicio"
                  v-mask="'99/99/9999'"
                  data-test-id="input-datainicio"
                  name="dataInicio"
                  type="text"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                />
                <div class="input-group-addon">
                  <span
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-calendar" />
                  </span>
                  <span class="dropdown-menu dropdown-menu-right">
                    <li>
                      <DatePicker
                        v-model="filtro.dataInicio"
                        :today-btn="false"
                        :clear-btn="false"
                        :format="'dd/MM/yyyy'"
                        :close-on-selected="true"
                        :date-parser="dataParser"
                        class="date-picker"
                      />
                    </li>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div
              :class="{ 'has-error': v$.filtro.dataInicio.$error }"
              class="form-group"
            >
              <label for="dataFim">Data Fim <sup>(1)</sup></label>
              <div class="input-group">
                <input
                  id="dataFim"
                  v-model="filtro.dataFim"
                  v-mask="'99/99/9999'"
                  data-test-id="input-datafim"
                  name="dataFim"
                  type="text"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                />
                <div class="input-group-addon">
                  <span
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-calendar" />
                  </span>
                  <span class="dropdown-menu dropdown-menu-right">
                    <li>
                      <DatePicker
                        v-model="filtro.dataFim"
                        :today-btn="false"
                        :clear-btn="false"
                        :format="'dd/MM/yyyy'"
                        :close-on-selected="true"
                        :date-parser="dataParser"
                        class="date-picker"
                      />
                    </li>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <br />
    <AgendamentosDesatualizadosTabela
      v-if="agendamentosDesativados.length"
      :agendamentos="agendamentosDesativados"
    />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import { useMenu } from '@/composables/useMenu'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import MensagemServico from '@/servicos/MensagemServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import UnidadeServico from '@/servicos/UnidadeServico'

import AgendamentosDesatualizadosTabela from './AgendamentosDesativadosTabela.vue'

const unidadeServico = new UnidadeServico()
const profissionalServico = new ProfissionalServico()
const mensagemServico = new MensagemServico()
const agendamentoServico = new AgendamentoServico()

export default {
  components: {
    DatePicker,
    BlocoFiltroPesquisa,
    AgendamentosDesatualizadosTabela,
  },
  directives: { mask: AwesomeMask },
  setup() {
    useMenu(58)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      agendamentosDesativados: [],
      unidades: [],
      gerado: false,
      filtro: {
        unidade: '',
        profissional: {},
        dataInicio: moment().startOf('month').format('DD/MM/YYYY'),
        dataFim: moment().endOf('month').format('DD/MM/YYYY'),
      },
    }
  },
  created() {
    this.recuperarUnidades()
  },
  validations: {
    filtro: {
      unidade: { required },
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Preencha os campos corretamente.')
      } else {
        agendamentoServico
          .relatorioAgendamentosDesativados({
            unidade: this.filtro.unidade,
            dataInicio: moment(this.filtro.dataInicio, 'DD/MM/YYYY').format(
              'YYYY-MM-DD'
            ),
            dataFim: moment(this.filtro.dataFim, 'DD/MM/YYYY').format(
              'YYYY-MM-DD'
            ),
          })
          .then((result) => {
            this.agendamentosDesativados = result.agendamentosDesativados
          })
      }
    },
    limparFiltro() {
      this.filtro.unidade = ''
      this.filtro.profissional = {}
      this.filtro.dataInicio = moment().startOf('month').format('DD/MM/YYYY')
      this.filtro.dataFim = moment().endOf('month').format('DD/MM/YYYY')
    },
    recuperarUnidades() {
      unidadeServico.recuperarTodos().then((result) => {
        this.unidades = result.unidades
      })
    },
    selecionarProfissional(profissional) {
      this.filtro.profissional = {
        _id: profissional._id,
        nome: profissional.nome,
      }
    },
    limparProfissional() {
      this.filtro.profissional = {}
    },
    recuperarProfissionais(filtro) {
      const data = {
        nome: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      profissionalServico.recuperarTodos(data).then((result) => {
        this.profissionais = result.profissionais

        this.profissionais.forEach((p) => {
          if (p.bloqueado) {
            p.nome = `${p.nome} (${p.motivo})`
          }
        })
      })
    },
    profissionalAtivo(item) {
      return !item.bloqueado
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
    marcarTodos() {
      this.agendamentosDesativadosSelecionada = []
      this.agendamentosDesativados.forEach((a) => {
        this.agendamentosDesativadosSelecionada.push(a)
      })
    },
    desmarcarTodos() {
      this.agendamentosDesativadosSelecionada = []
    },
  },
}
</script>

<style scoped>
.cell {
  vertical-align: middle;
}

.nome_profissional {
  margin: 0 15px;
  font-size: 16px;
  color: #ecf0f1;
}

.resumo_profissional {
  margin: 0 5px;
  font-size: 14px;
  color: #ecf0f1;
}

.tabela-head {
  font-weight: 600;
  color: #ecf0f1;
}
</style>
